/**
 * @generated SignedSource<<d5fc2ec0b28275c3d028e771847d370f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SalesPeriod = {
  endAt: any;
  startAt: any;
};
export type IndicatorCards_indicators_refetch$variables = {
  period: SalesPeriod;
  salesAssociateId: string;
  storeId: string;
};
export type IndicatorCards_indicators_refetch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IndicatorCards_indicators">;
};
export type IndicatorCards_indicators_refetch = {
  variables: IndicatorCards_indicators_refetch$variables;
  response: IndicatorCards_indicators_refetch$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "period"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "salesAssociateId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "kind": "Variable",
  "name": "period",
  "variableName": "period"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "averageItemAmount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "averageItemsPerSale",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "averageSalesAmount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IndicatorCards_indicators_refetch",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "IndicatorCards_indicators"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IndicatorCards_indicators_refetch",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VtexUser",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Brand",
            "kind": "LinkedField",
            "name": "brand",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyCode",
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "store",
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "storeId"
          }
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "fields": [
                      (v3/*: any*/)
                    ],
                    "kind": "ObjectValue",
                    "name": "where"
                  }
                ],
                "concreteType": "SalesIndicators",
                "kind": "LinkedField",
                "name": "salesIndicators",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Store",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "salesAssociate",
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "salesAssociateId"
          }
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "fields": [
                      (v3/*: any*/),
                      {
                        "fields": [
                          {
                            "kind": "Variable",
                            "name": "eq",
                            "variableName": "storeId"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "storeId"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "where"
                  }
                ],
                "concreteType": "SalesIndicators",
                "kind": "LinkedField",
                "name": "salesIndicators",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "salesAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "salesQuantity",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalItemsSold",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "SalesAssociate",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "406421ac8f7f8103e06916a15625382b",
    "id": null,
    "metadata": {},
    "name": "IndicatorCards_indicators_refetch",
    "operationKind": "query",
    "text": "query IndicatorCards_indicators_refetch(\n  $period: SalesPeriod!\n  $salesAssociateId: ID!\n  $storeId: ID!\n) {\n  ...IndicatorCards_indicators\n}\n\nfragment IndicatorCards_indicators on Query {\n  viewer {\n    brand {\n      currencyCode\n      id\n    }\n  }\n  store: node(id: $storeId) {\n    __typename\n    ... on Store {\n      salesIndicators(where: {period: $period}) {\n        averageItemAmount\n        averageItemsPerSale\n        averageSalesAmount\n      }\n      __typename\n    }\n    id\n  }\n  salesAssociate: node(id: $salesAssociateId) {\n    __typename\n    ... on SalesAssociate {\n      salesIndicators(where: {storeId: {eq: $storeId}, period: $period}) {\n        salesAmount\n        salesQuantity\n        totalItemsSold\n        averageItemAmount\n        averageItemsPerSale\n        averageSalesAmount\n      }\n      __typename\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "655264f8525eaa15479ed63cbfe938b4";

export default node;
